import React from 'react';

import {
  useCreateMultipleTaskTemplates,
  useCreateTaskTemplate,
  useTriggerTaskTemplate,
} from 'app/tasks/api';

import {BaseAssignTaskModal} from './BaseAssignTaskModal';

import type {
  TaskTemplateSerializedType,
  WriteTaskTemplateSerializedType,
} from 'sweet-types';

interface Props {
  show: boolean;
  onToggle: () => unknown;
  taskData?: Partial<WriteTaskTemplateSerializedType>;
  skipSuccessNotification?: boolean;
  onAssignSuccess?: (
    response: // it will be an object if createTaskTemplate or triggerTaskTemplate is used
    | {
          task: TaskTemplateSerializedType;
          // this will be populated when the task was created using the trigger endpoint
          html_url?: string;
        }
      // it will be a string if createMultipleTaskTemplates is used
      | string
  ) => unknown;
}

export function AssignNewTaskModal({
  onAssignSuccess,
  skipSuccessNotification,
  ...props
}: Props) {
  const [createTaskTemplate] = useCreateTaskTemplate();
  const [triggerTaskTemplate] = useTriggerTaskTemplate();
  const [createMultipleTaskTemplates] = useCreateMultipleTaskTemplates();

  return (
    <BaseAssignTaskModal
      canChangeDoc={props.taskData?.object_id == null}
      {...props}
      assignAction={({task, document, isMultiAssign}) =>
        document.can_assign
          ? isMultiAssign
            ? createMultipleTaskTemplates(task)
                .unwrap()
                .then((job) => {
                  onAssignSuccess?.(job.result.url);
                  return task;
                })
            : createTaskTemplate(task)
                .unwrap()
                .then((task) => {
                  onAssignSuccess?.({task});
                  return task;
                })
          : triggerTaskTemplate({task, skipSuccessNotification})
              .unwrap()
              .then(({template, html_url}) => {
                onAssignSuccess?.({task: template, html_url});
                return task;
              })
      }
    />
  );
}
